import React, { useEffect, useState } from 'react';
import { getCompanyInfo } from '../../api/config';

const Terms = () => {
    const [info, setInfo] = useState({
        name: '가까운솔루션'
    });

    useEffect(() => {
        // 맨 위로 올리는 것은 ScrollManager 가 모든 페이지에 대해 한다.
        const fetchInfo = async () => {
            try {
                const data = await getCompanyInfo();
                if (data) setInfo(prev => ({ ...prev, ...data }));
            } catch (err) {
                console.error('Failed to load terms info', err);
            }
        };
        fetchInfo();
    }, []);

    const styles = {
        container: {
            maxWidth: '800px',
            margin: '0 auto',
            padding: '4rem 2rem',
            lineHeight: '1.6',
            color: '#333',
            fontFamily: 'Pretendard, sans-serif'
        },
        title: {
            fontSize: '2rem',
            fontWeight: 'bold',
            marginBottom: '2rem',
            paddingBottom: '1rem',
            borderBottom: '2px solid #333'
        },
        section: {
            marginBottom: '2.5rem'
        },
        sectionTitle: {
            fontSize: '1.2rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            color: '#1a237e'
        },
        text: {
            marginBottom: '0.5rem',
            fontSize: '1rem',
            color: '#555'
        },
        list: {
            paddingLeft: '1.5rem',
            marginBottom: '1rem'
        },
        listItem: {
            marginBottom: '0.5rem',
            color: '#555'
        }
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>이용약관</h1>

            <p style={styles.text}>
                본 약관은 '{info.name}'(이하 '회사')이 제공하는 웹사이트 및 제반 서비스(이하 '서비스')의 이용과 관련하여 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
            </p>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제1조 (견적 산출 서비스의 면책)</h2>
                <ol style={styles.list}>
                    <li style={styles.listItem}>회사가 웹사이트를 통해 제공하는 '예상 견적 산출' 서비스의 결과값은 이용자의 입력 정보를 바탕으로 한 단순 추정치입니다.</li>
                    <li style={styles.listItem}>본 견적 결과는 실제 계약 체결 시의 최종 금액과 차이가 있을 수 있으며, 법적인 구속력이나 효력을 갖지 않습니다.</li>
                    <li style={styles.listItem}>정확한 견적 및 계약 진행을 위해서는 반드시 회사의 담당자와 별도의 실무 협의를 거쳐야 합니다.</li>
                    <li style={styles.listItem}>회사는 이용자가 예상 견적 결과만을 신뢰하여 발생한 손해에 대해 책임을 지지 않습니다.</li>
                </ol>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제2조 (저작권의 귀속 및 이용제한)</h2>
                <ol style={styles.list}>
                    <li style={styles.listItem}>회사가 작성한 저작물(텍스트, 이미지, 로고, 디자인, 소스코드 등)에 대한 저작권 및 기타 지적재산권은 회사에 귀속합니다.</li>
                    <li style={styles.listItem}>이용자는 서비스를 이용함으로써 얻은 정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</li>
                </ol>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제3조 (서비스 이용의 제한)</h2>
                <p style={styles.text}>회사는 다음 각 호에 해당하는 경우 서비스 이용을 제한하거나 중지할 수 있습니다.</p>
                <ol style={styles.list}>
                    <li style={styles.listItem}>서비스 시스템의 점검, 보수 또는 공사로 인하여 부득이한 경우</li>
                    <li style={styles.listItem}>이용자가 비정상적인 방법으로 서비스를 이용하거나 시스템에 부하를 주는 경우 (예: 자동화된 스크래핑 시도 등)</li>
                    <li style={styles.listItem}>기타 회사가 서비스를 제공할 수 없는 합리적인 사유가 발생한 경우</li>
                </ol>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>제4조 (약관의 개정)</h2>
                <p style={styles.text}>회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을 개정할 수 있으며, 개정된 약관은 웹사이트에 공지함으로써 효력이 발생합니다.</p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>부칙</h2>
                <p style={styles.text}>본 약관은 2026년 1월 1일부터 시행합니다.</p>
            </div>
        </div>
    );
};

export default Terms;
